import React, {useEffect, useState} from "react";
import {getOrderForm, paymentResult} from "../Wizard/_redux/wizardCrud";
import {useLocation, Link} from "react-router-dom";
import {Button, Table} from "react-bootstrap";
import k1utils from "../../../util/k1utils";
import {Card, CardBody, CardHeader, CardFooter} from "../../../_metronic/_partials/controls/Card"
import moment from "moment/moment";
import './hrOption.css'

// const initialState = {
//     notification: {},
//     orderForm: { optionList:[], },
//     order: { order_value:[], },
//     orderStatus: 5001,
//     store: {},
//     calStep: undefined,
//     workTypeValue: "ORDER"
// }

// export const SET_NOTIFICATION = "SET_NOTIFICATION";
// export const SET_STATUS = "SET_STATUS";
// const reducer = (state, action) => {
//     switch (action.type) {
//         case SET_NOTIFICATION :
//             return{
//                 ...state,
//                 notification: action.notification,
//                 orderForm: action.orderForm,
//                 order: action.order,
//                 orderStatus: action.orderStatus,
//                 store: action.store,
//                 calStep: action.calStep,
//                 workTypeValue: action.workTypeValue
//             }
//         case SET_STATUS:
//             const copyOrder = {...state.order};
//             copyOrder.order_status = action.status;
//             return{
//                 ...state,
//                 order: copyOrder,
//             }
//         default :
//             throw new Error();
//     }
// }

// const notificationStatus = status => (status === 5002 || status === 5009 || status === 5010);

// const orderSheetStatus = status => (status === 5003 || status === 5004 || status === 5005 || status === 5006 || status === 5007 || status === 5008);

export const PaymentPage = () => {
    // const [orderKey, setOrderKey] = useState();
    // const [paymentKey, setPaymentKey] = useState();

    const [payResult, setPayResult] = useState()

    const [order, setOrder] = useState();

    // const history = useHistory();
    // const tossPaymentsRef = useRef(null);



    //TODO:
    // 1. 성공 / 실패 여부 판단 
    // 2. 성공 --> 컨펌 받고 toss = '결제 승인' 호출, 결제 승인이 '성공' 하면 '/k/주문서 페이지' 로 이동
    // 3. 실패 --> 서버에 저장하고 실패메시지 보여주고, '/k/주문서 페이지' 로 이동


    const location = useLocation();
    const pay_method = location?.pathname.split("/")[1];
    const pay_result = location?.pathname.split("/")[2];


    useEffect(() => {
    // parameter check start[
  
      const _getParameter = (key) => {
        return new URLSearchParams(location.search).get(key);
      };
        
      setPayResult( {
        orderId: _getParameter('orderId'),
        paymentKey: _getParameter('paymentKey'),
        amount: _getParameter('amount')
      })
    //   setOrderKey(getParameter('orderId'))
    //   setPaymentKey(getParameter('paymentKey'))
    //   const amount = getParameter('amount')

    //   console.log("amount[" + amount + "]")
      // parameter check end] 
    }, [location])

    useEffect(() => {
        if (undefined !== payResult) {
            getOrderForm(payResult.orderId)
                .then(res => {
                    const result = res.data.data
                    setOrder(result.order)
                })
                .catch(err => {
                    console.error(err)
                    // setErr(JSON.stringify(err?.response?.data));
                })
        }
    },[payResult]);

    const tossPaymentConfirm = () => {
        const tossApi = `https://api.tosspayments.com/v1/payments/confirm`

        return fetch(tossApi, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : 'Basic ' + btoa(process.env.REACT_APP_TOSS_SECRET_KEY + ':')
            },
            body: JSON.stringify(payResult),
        }) 
        .then( (response) => { 
            return response; 
        })

    }

   const getContents = (data) => {
        let result = "";
        data.forEach((data) => {
          if(data.t_fileidx === 0 && data.contents !== '') {
              result = data.contents;
          }
        });
        return result;
    }

   const getImage = (data) => {
       let result = "";
       data.forEach((data) => {
         if(data.t_fileidx !== 0) result = data.t_fileidx;
       });
       return result;
   }
    const payConfirm = () => {
        const millisec = new Date().getTime();
        tossPaymentConfirm()
        .then(async (response) => {
            if (response.status === 200) {
                const body = await response.json();
                // console.log("200 [" + JSON.stringify(body) +  "]");
                // debugger
                // 정상 처리
                // 서버에 결제 정보 저장
                paymentResult(pay_method, pay_result, body)
                .then( (res) => {
                    window.location.replace(`/k/${payResult.orderId}/${millisec}`)
                }).error ( (error) => {
                    window.location.replace(`/k/${payResult.orderId}/${millisec}`)
                })
                // 다시 주문서로 이동 시키기
            } else {
                // console.error("save payResult(fail) to server is failed!")
                window.location.replace(`/k/${payResult.orderId}/${millisec}`)
            }
        })
        .catch(error => {
            // console.error("error")
            window.location.replace(`/k/${payResult.orderId}/${millisec}`)
        })
    }

    if (order === undefined) return ('')

    const orderImageUrl = k1utils.toSmallFileUrl(getImage(order.order_reference));

    return (
        <Card className="example example-compact">
            <CardHeader title="주문상세정보"/>
            <CardBody>
                <h1><b>고객정보</b></h1>
                <hr/>
                <Table bordered striped>
                    <tbody>
                    <tr className='p-0'>
                        <th className='bg-dark text-white'>
                            이름
                        </th>
                        <td>{order.buyer_name}</td>
                    </tr>
                    <tr className='p-0'>
                        <th className='bg-dark text-white'>
                            연락처
                        </th>
                        <td>{k1utils.phoneNumberFormat(order.buyer_mobile_phone)}</td>
                    </tr>
                    <tr className='p-0'>
                        <th className='bg-dark text-white'>
                            픽업
                        </th>
                        <td>{moment(order.pickup_dtm).format('YYYY-MM-DD HH:mm')}</td>
                    </tr>
                    </tbody>
                </Table>

                <br />
                <h1><b>결제금액정보</b></h1>
                <hr />
                    <Table>
                      <tbody>
                        <tr>
                            <th className="bg-dark text-white">산정가격</th>
                            <th className="bg-dark text-white">수량</th>
                            <th className="bg-dark text-white">배송비</th>
                            <th className="bg-dark text-white">총금액</th>
                        </tr>
                      <tr>
                          <th className="bg-light text-black-50">{order.price}원</th>
                          <th className="bg-light text-black-50">{order.quantity}개</th>
                          <th className="bg-light text-black-50">{order.price_delivery}원</th>
                          <th className="bg-light text-black-50">{ (order.price * order.quantity) + order.price_delivery }원</th>
                      </tr>
                      </tbody>
                    </Table>
                <br />
                <h1><b>상품예시이미지</b></h1>
                <hr />
                <div className="image-container">
                    <img src={orderImageUrl} alt="" className="scaled-image"/>
                </div>
                <br />
                <h1><b>디자인설명</b></h1>
                <hr/>
                <Table>
                    <tbody>
                    <tr>
                        <th className="bg-light text-black-50">{getContents(order.order_reference)}</th>
                    </tr>
                    </tbody>
                </Table>
            </CardBody>
            <CardFooter>
                <Button onClick ={payConfirm}>
                    결제승인
                </Button>
                <Link to={`/k/${payResult.orderId}/${new Date().getTime()}`}>
                    <Button style={{marginLeft: 1 + 'em'}}>
                    결제취소
                </Button>
                </Link>
            </CardFooter>
      </Card>
    );
};
